<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span class="mt-2 secondary--text">
            {{ months[getDate.getMonth()] }} {{ getDate.getDate()
            }}, {{getDate.getFullYear()}}
          </span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">MERCHANTS</h3>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="merchants"
              :pagination.sync="pagination"
              :total-items="totalMerchants"
              :loading="loading"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute(`/admin/merchants/${props.item.id}`)">
                  <td>
                    <h3 class="font-weight-regular" v-text="props.item.name"></h3>
                    <!--<h4-->
                    <!--class="font-weight-regular"-->
                    <!--v-text="props.item.business_type"></h4>-->
                  </td>
                  <td class v-text="props.item.business_type"></td>
                  <td class v-text="props.item.category"></td>
                  <td class v-text="props.item.phone"></td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" merchant has no results.</v-alert>
            </v-data-table>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import AdminLayout from "../../layouts/admin"
import { mapState, mapGetters } from "vuex"
import { FETCH_MERCHANTS } from "../../store/actions/merchant"
import { debounce } from "lodash"  

export default {
  name: "Admin",
  data() {
    return {
      page_title: "Merchants",
      getDate: new Date(),
      pagination: {
        rowsPerPage: 25
      },
      search: "",
      loading: false,
      headers: [
        {
          text: "Merchant",
          align: "left",
          value: "name"
        },
        { text: "Business Type", value: "business_type" },
        { text: "Category", value: "category" },
        { text: "Phone", value: "phone" }
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      }
    },
    search: function(newQuery, oldQuery) {
      this.loading = true
      this.debouncedSearchApi()
    }
  },
  methods: {
    toroute(route) {
      this.$router.push(route)
    },
    getDataFromApi() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // Fetch data with page
      this.$store
        .dispatch(FETCH_MERCHANTS, {
          page: page,
          page_size: rowsPerPage,
          search: this.search
        })
        .then(() => {
          this.loading = false
        })
    },
    searchApi() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      this.$store
        .dispatch(FETCH_MERCHANTS, {
          page: 1,
          page_size: rowsPerPage,
          search: this.search
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapState({
      merchants: state => state.merchant.merchants,
      totalMerchants: state => state.merchant.merchantsCount
    })
  },
  created() {
    this.$emit("update:layout", AdminLayout)
    this.debouncedSearchApi = debounce(this.searchApi, 1000)
  },
  mounted() {
    this.$store.dispatch(FETCH_MERCHANTS, { page: 1, page_size: 25 })
  }
}
</script>